module.exports = __webpack_public_path__ + "img/roy.eaa14981.png";